import { render, staticRenderFns } from "./CDEKTable.vue?vue&type=template&id=266654e6&scoped=true"
import script from "./CDEKTable.vue?vue&type=script&lang=js"
export * from "./CDEKTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266654e6",
  null
  
)

export default component.exports